import { EnvironmentHelper } from "@repo/helpers";
import { type PageProps } from "gatsby";
import { createContext, type FC, type PropsWithChildren, useContext, useMemo } from "react";

type IContractIDContext = {
    contractId: string;
    proposalNumber?: string | null;
};
export const ContractIDContext = createContext<IContractIDContext>({ contractId: "", proposalNumber: undefined });

export function useContractId(): IContractIDContext {
    return useContext(ContractIDContext);
}

export function extractContractIDFromPageProps(pageProps: PageProps): string {
    if (EnvironmentHelper.isBuild()) return "";
    const url = new URL(pageProps.location.href);
    const id = url.searchParams.get("cislo");
    if (!id) throw new Error("Missing contract number");
    return id;
}

export type ContractIDProviderProps = PropsWithChildren<{
    contractId: string;
    proposalNumber?: string | null;
}>;

export const ContractIDProvider: FC<ContractIDProviderProps> = ({ children, contractId, proposalNumber }) => {
    const value = useMemo(() => ({ contractId, proposalNumber }), [contractId, proposalNumber]);
    return <ContractIDContext.Provider value={value}>{children}</ContractIDContext.Provider>;
};
